import React from 'react';
import classNames from 'classnames';
import PaginationOverflowItem from './PaginationOverflowItem';
import { PaginationItemsProps } from './PaginationItemsProps';
import range from './range';
import PaginationItem from './PaginationItem';

export default function PaginationItemsUnbounded({
  current,
  items,
  labels,
  itemLink: ItemLink,
  itemOnClick,
}: PaginationItemsProps): JSX.Element {
  if (items <= 6 || current <= 3) {
    return (
      <>
        {range(0, 6).map((value) => {
          const displayCurrentIndex = value + 1;
          return (
            <PaginationItem key={`${value}-pagination-item`}>
              <ItemLink
                className={classNames('usa-pagination__button', { 'usa-current': value === current })}
                aria-label={`${labels.pageLabel} ${displayCurrentIndex}`}
                aria-current={value === current ? 'page' : undefined}
                page={value}
                onClick={() => itemOnClick(value)}
              >
                {displayCurrentIndex}
              </ItemLink>
            </PaginationItem>
          );
        })}
        <PaginationOverflowItem />
      </>
    );
  }

  return (
    <>
      <PaginationItem>
        <ItemLink
          className="usa-pagination__button"
          aria-label={`${labels.pageLabel} 1`}
          page={0}
          onClick={() => itemOnClick(0)}
        >
          1
        </ItemLink>
      </PaginationItem>
      <PaginationOverflowItem />
      {range(current - 1, current + 3).map((value) => {
        const displayCurrentIndex = value + 1;
        return (
          <PaginationItem key={`${value}-pagination-item`}>
            <ItemLink
              className={classNames('usa-pagination__button', { 'usa-current': value === current })}
              aria-label={`${labels.pageLabel} ${displayCurrentIndex}`}
              aria-current={value === current ? 'page' : undefined}
              page={value}
              onClick={() => itemOnClick(value)}
            >
              {displayCurrentIndex}
            </ItemLink>
          </PaginationItem>
        );
      })}
      <PaginationOverflowItem />
    </>
  );
}
